const apiUrl = API_URL; // eslint-disable-line no-undef

export default apiUrl;



// WEBPACK FOOTER //
// ./src/services/api_url.js